export { Avatar } from './avatar';
export type { AvatarProps } from './avatar';
